import { useEffect, useState, useCallback, useRef } from "react";
import useSWR, { mutate, SWRConfiguration } from "swr";
import { IProgram, IRequestPrograms, IRequestGetLink, IResponseGetLink } from "../services/typings/program";
import programServices from "../services/programServices";

export const useGetPromotions = (param: IRequestPrograms, config: SWRConfiguration = {}) => {
  const { data, error, mutate, isValidating } = useSWR<IProgram[]>(
    ["get_programs", param.order, param.sort_by],
    () => programServices.getPrograms(param),
    {
      refreshWhenHidden: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      ...config,
    }
  );
  const loading = isValidating;
  return { data, error, mutate, loading };
};

export const useGetPromotion = (id: any, config: SWRConfiguration = {}) => {
  const { data, error, mutate, isValidating } = useSWR<IProgram>(
    id ? id : null,
    programServices.getProgram,
    {
      refreshWhenHidden: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      ...config,
    }
  );
  const loading = isValidating;
  return { data, error, mutate, loading };
};

export const useGetLink = (config: SWRConfiguration = {}) => {
  const [loading, setLoading] = useState(false);

  const mounted = useRef(true);

  useEffect(
    () => () => {
      mounted.current = false;
    },
    []
  );

  const getLink = useCallback(
    async (params: IRequestGetLink) => {
      try {
        if (!params.program_id || !params.original_link) throw new Error("Missing Params");
        setLoading(true);
        const res = await programServices.getLink(params);
        return res;
      } catch (e) {
        throw e;
      } finally {
        mounted.current && setLoading(false);
      }
    },
    [setLoading]
  );

  return [getLink, loading] as const;
};